import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=f552dc72&"
import script from "./GiftList.vue?vue&type=script&lang=js&"
export * from "./GiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports